<a [routerLink]="link" *ngIf="isInternal">
    <ng-content></ng-content>
</a>

<a href="{{link}}" *ngIf="!isInternal" target="_blank">
    <ng-content></ng-content>
</a>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/link.button/link.button.component.html